import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import * as actions from '../actions';
import delay from 'xstream/extra/delay';
import sampleCombine from 'xstream/extra/sampleCombine';
import HEADER_FUNCTIONS from '../utils/functions/headers';
import i18n from '../i18n/i18n';

const REQUEST_QUESTION_VALIDATION_RULE = 'requestQuestionValidationRule';

export function requestQuestionValidationRule(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(action => {
        return action.type === ActionTypes.FETCH_QUESTION_VALIDATION_RULE;
    })
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url: GENERAL_FUNCTIONS.getBaseURL() + 'api/QuestionValidationRule',
            // The rule descriptions and regExExpressions are localised server
            // side off this header. Without it the API has no way to know the
            // language changed and keeps returning the previous locale.
            headers: {
                ...HEADER_FUNCTIONS.headersWithTokenJson(token),
                'Accept-Language': i18n.language,
            },
            category: REQUEST_QUESTION_VALIDATION_RULE,
            method: 'GET',
        }));

    let httpResponse$ = sources.HTTP.select(REQUEST_QUESTION_VALIDATION_RULE)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchQuestionValidationRuleSuccess(response)
                : actions.fetchQuestionValidationRuleFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}
